/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import noop from 'lodash/noop';

import { Block, Checkbox, ErrorMessage } from '@atoms';
import { TextField } from '@molecules';
import RichTextField from '@molecules/RichTextField';
import { Form } from '@organisms';

import MediaField from '../MediaField';

import { FORM_FIELD, GENERAL_CHANNELS } from './constants';
import EventChannels from './EventChannelsForm';

const TITLE_STYLE = {
  lineHeight: '170%',
  fontWeight: 800,
  fontSize: 22,
};

const WhereToWatchForm = ({ initialValues = {}, error, form, eventName, countries, whereToWatchDays }) => {
  const handleSetLive = useCallback((e) => form.setFieldsValue({ [FORM_FIELD.LIVE.name]: e.target.checked }), [form]);

  return (
    <>
      <Form form={form} layout="vertical" initialValues={initialValues}>
        {error?.response.status === 404 ? (
          <Block variant="error" spaced>
            Where to watch not created for this event yet.
          </Block>
        ) : (
          <ErrorMessage error={error} variant="block" spaced />
        )}
        <Block spaced>
          <h1 style={TITLE_STYLE}>{eventName}</h1>
          <RichTextField multiline {...FORM_FIELD.INTRO_TEXT} />
          <RichTextField multiline {...FORM_FIELD.BOTTOM_TEXT} />
          <TextField multiline {...FORM_FIELD.BANNER_STRAPLINE} />
          <MediaField {...FORM_FIELD.DESKTOP_BANNER} />
          <MediaField {...FORM_FIELD.MOBILE_BANNER} />
          <TextField {...FORM_FIELD.BANNER_URL} />
          <Form.Item valuePropName="checked" {...FORM_FIELD.LIVE}>
            <Checkbox onChange={handleSetLive}>Set Live</Checkbox>
          </Form.Item>
        </Block>
        <Form.List {...GENERAL_CHANNELS}>{noop}</Form.List>
      </Form>

      <EventChannels
        whereToWatchDays={whereToWatchDays}
        initialValues={initialValues}
        countries={countries}
        form={form}
      />
    </>
  );
};

WhereToWatchForm.useForm = () => Form.useForm(FORM_FIELD);

export default WhereToWatchForm;
